import { useQuery } from "react-query";
import { IOption } from "component-library/src/components/Atoms/FormikInputs/SelectFormik/SelectFormik";

import { QueryKeys } from "../constants/QueryKeys";
import { agentsService } from "../services";

export const useAgencyOptions = () => {
  const { data, isLoading, refetch } = useQuery(
    [QueryKeys.FETCH_AGENCIES],
    async () => {
      const agencies = await agentsService.getAgencies({
        agentsorschools: "agents",
        performerType: 1,
      });

      if (!agencies || agencies.length === 0) return [] as IOption[];

      return agencies.map(({ name, refNumber }) => ({
        label: name,
        value: refNumber,
      })) as IOption[];
    },
    {
      cacheTime: Infinity,
      staleTime: Infinity,
    }
  );

  return {
    agencyOptions: data || [],
    fetchingAgencyOptions: isLoading,
    fetchAgencyOptions: refetch,
  };
};
